import { Box } from "@mui/material";
import React, { ReactNode } from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { DangerButton } from "../../Button/DangerButton";
import { ConfirmationButton } from "../../Button/ConfirmationButton";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";

interface IDialogButtonsProps {
    isNew?: boolean;
    prefixNode?: ReactNode;
    printDisabled?: boolean;
    removeDisabled?: boolean;
    archiveDisabled?: boolean;
    restoreFromArchiveArchiveDisabled?: boolean;
    saveDisabled?: boolean;
    cancelTitle?: string;
    removeTitle?: string;
    archiveTitle?: string;
    restoreFromArchiveTitle?: string;
    saveTitle?: string;
    onCancel: () => void;
    onPrint?: () => Promise<void>;
    onRemove?: () => Promise<void>;
    onArchive?: () => Promise<void>;
    onRestoreFromArchive?: () => Promise<void>;
    onSave?: () => Promise<void> | Promise<any> | void;
}

export const DialogButtons = ({
    isNew,
    prefixNode,
    printDisabled,
    removeDisabled,
    archiveDisabled,
    restoreFromArchiveArchiveDisabled,
    saveDisabled,
    cancelTitle,
    removeTitle,
    archiveTitle,
    restoreFromArchiveTitle,
    saveTitle,
    onCancel,
    onPrint,
    onRemove,
    onArchive,
    onRestoreFromArchive,
    onSave
}: IDialogButtonsProps) => (
    <Box display="flex">
        {prefixNode}
        {!!onRemove &&
            <DangerButton onClick={onRemove} disabled={removeDisabled} sx={{ marginRight: "1.5rem" }}>{removeTitle ?? Translations.Remove}</DangerButton>
        }
        {!!onArchive &&
            <AppButton variant="outlined" onClick={onArchive} disabled={archiveDisabled} sx={{ marginRight: "1.5rem" }}>{archiveTitle ?? Translations.Archive}</AppButton>
        }
        {!!onRestoreFromArchive &&
            <AppButton variant="outlined" onClick={onRestoreFromArchive} disabled={restoreFromArchiveArchiveDisabled} sx={{ marginRight: "1.5rem" }}>{restoreFromArchiveTitle ?? Translations.Restore}</AppButton>
        }
        {!!onPrint &&
            <AppButton variant="outlined" onClick={onPrint} disabled={printDisabled} sx={{ marginRight: ".5rem" }}>{Translations.Print}</AppButton>
        }
        <AppButton variant="outlined" onClick={onCancel} sx={{ marginRight: onSave ? ".5rem" : undefined }}>{!cancelTitle ? (isNew ? Translations.Cancel : Translations.Close) : cancelTitle}</AppButton>
        {!!onSave &&
            <ConfirmationButton onClick={onSave} disabled={saveDisabled}>{saveTitle ?? Translations.Save}</ConfirmationButton>
        }
    </Box>
);
